module.exports = __webpack_public_path__ + "static/img/1810_3.de145f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1810_3.jpg
// module id = Fnbk
// module chunks = 1